import { makeAutoObservable } from 'mobx'
import { TextareaStore } from 'store/textareaStore'

export class ConversationSendMessageStore {
  smsStore
  noteStore
  constructor() {
    this.smsStore = new TextareaStore()
    this.noteStore = new TextareaStore()
    makeAutoObservable(this)
  }

  type: 'SMS' | 'NOTE' = 'SMS'
  setType = (type: typeof this.type) => {
    this.type = type
  }
}
